import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PortalPatientApi from 'api/patient/PortalPatientApi';
import ModalBoxes, { useModalBoxes } from 'common/feedback/ModalBoxes/ModalBoxes';
import Button from 'common/general/Button';
import ButtonGroup from 'common/general/ButtonGroup';
import NotificationManager from 'common/notifications/NotificationManager';
import { onRequestError } from 'services/handlers';
import { getPatientFullName } from 'services/patient';

import { NSPP_ENABLEMENT } from '../../../../../../../../../services/i18n/namespaces';

import './PatientPortalInvitationModal.scss';

export default function PatientPortalInvitationModal({ modalBox, patientInfo }) {
  const { t } = useTranslation();
  const { id, email } = patientInfo;
  const { loading, setLoading } = useModalBoxes();
  const [duplicate, setDuplicate] = useState(null);

  useEffect(() => {
    setLoading(true);
    PortalPatientApi.getPatientWithDuplicatedEmail(id, email)
      .then(function({ data }) {
        if (data?.email) {
          setDuplicate(data);
        }
      })
      .finally(function() {
        setLoading(false);
      });
  }, [email, id, setLoading]);

  return (
    <>
      <ModalBoxes.Header>
        {!duplicate
          ? t(`${NSPP_ENABLEMENT}:portal.participantPortalInvitation`)
          : t(`${NSPP_ENABLEMENT}:portal.duplicatePatientFound`)}
      </ModalBoxes.Header>
      <ModalBoxes.Body>
        {!loading && !duplicate && `${t(`${NSPP_ENABLEMENT}:portal.patientEmail`)}: ${email}`}
        {!loading && duplicate && (
          <>
            <p>
              {t(`${NSPP_ENABLEMENT}:portal.patientDuplicateFound`, {
                patientFullName: getPatientFullName(duplicate),
                email: duplicate.email,
                patientId: duplicate.patientId
              })}
            </p>
            <b>{t(`${NSPP_ENABLEMENT}:portal.invitationOnlyUnique`)}</b>
          </>
        )}
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            {t('cancel')}
          </Button>
          {!loading && !duplicate && <Button onClick={invite}>{t(`${NSPP_ENABLEMENT}:portal.invite`)}</Button>}
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
  function invite() {
    setLoading(true);
    PortalPatientApi.inviteToPortal(id).then(
      function({ data }) {
        NotificationManager.success(`Success! The patient invite has been sent via email.`);
        modalBox.close(data);
      },
      function(e) {
        modalBox.close(e);
        onRequestError(e);
      }
    );
  }
}

PatientPortalInvitationModal.className = 'patient-portal-invitation-modal';
PatientPortalInvitationModal.size = 'w650';
